<template>
  <Dialog
    title="自定义显示列"
    :visible="visible"
    @close="handleClose"
    width="600px"
  >
    <div
      v-for="option in options"
      :key="option.key"
      class="group"
    >
      <!-- 全选按钮 -->
      <Checkbox
        v-model="option.isCheckAll"
        :indeterminate="option.isIndeterminate"
        @change="handleCheckAllChange($event, option)"
      >
        <span class="group-name">{{ option.name }}</span>
      </Checkbox>

      <div style="margin: 20px 0;" />

      <!-- 单个列选项 -->
      <Checkbox
        v-for="column in option.children"
        :key="column.key"
        v-model="column.isSelected"
        :disabled="column.disabled"
        :label="column.key"
        class="checkbox"
        @change="handleChange($event, column, option)"
      >
        {{ column.name }}
      </Checkbox>
    </div>

    <span
      slot="footer"
      class="footer"
    >
      <Button @click="handleCancel">取消</Button>
      <Button
        type="primary"
        @click="handleConfirm"
      >
        确定
      </Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Button, Checkbox } from 'element-ui';
import { cloneDeep } from 'lodash';

export default {
  components: {
    Dialog,
    Button,
    Checkbox,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    // 选项
    dataSource: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      options: this.init(this.dataSource),
    };
  },

  methods: {
    init(data) {
      const that = this;
      return cloneDeep(data).map((item) => {
        // 初始化全选按钮
        that.$set(item, 'isCheckAll', that.isCheckAll(item.children));
        that.$set(item, 'isIndeterminate', that.isIndeterminate(item.children));
        return item;
      });
    },

    handleClose() {
      this.$emit('update:visible', false);
    },

    // 点击选项按钮
    handleCheckAllChange(val, option) {
      option.isIndeterminate = false;
      option.children = option.children.map((item) => {
        item.isSelected = val;
        return item;
      });
    },

    // 点击单个选项
    handleChange(val, col, parent) {
      col.isSelected = val;
      parent.isCheckAll = this.isCheckAll(parent.children);
      parent.isIndeterminate = this.isIndeterminate(parent.children);
    },

    // 是否全选
    isCheckAll(list) {
      const length = list.length;
      const selectedLength = list.filter((item) => item.isSelected).length;

      return selectedLength === length && length > 0;
    },

    // 是否部分选中
    isIndeterminate(list) {
      const length = list.length;
      const selectedLength = list.filter((item) => item.isSelected).length;

      return selectedLength < length && selectedLength > 0;
    },

    handleCancel() {
      this.handleClose();
    },

    handleConfirm() {
      this.handleClose();
      this.$emit('change', cloneDeep(this.options));
    },
  },
};
</script>

<style lang="less" scoped>
.group {
  margin-bottom: 32px;
}

.group-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.checkbox {
  margin-bottom: 20px;
}

.footer {
  display: flex;
  justify-content: center;
}
</style>
